import { render, staticRenderFns } from "./LabelTypeSelection.vue?vue&type=template&id=4b162af2&scoped=true"
import script from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabelTypeSelection.vue?vue&type=style&index=0&id=4b162af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b162af2",
  null
  
)

export default component.exports